export const css = {
    root: '_2CQW90hR',
    ' _key': 'afcpe-theme/afcpe/variants/afc1'
};
export default css;
